import React, { ReactElement, Component, useState, useCallback, useMemo } from 'react';
// import { withRouter } from "react-router";
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Input, Button, Card, notification, Form } from 'antd';
import { LOGIN_URL, GetQueryString } from './login-util';
import { http_request_new } from '../../http-worker/http-func';

export const ResetPwd = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [button_loading, set_button_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
  const { intl, history } = props;
  const [form] = Form.useForm();
  const { getFieldsValue } = form;
  const sso_path = useMemo(() => props.sso_path?.replace(/^\//, '') || 'v4.0', [props.sso_path]);
  const props_new = useMemo(
    () => ({
      history: props.history,
      redirect_url: props.redirect_url,
      log_out: props.log_out
    }),
    [props.history, props.redirect_url, props.log_out]
  );

  const username = useMemo(() => {
    if (props.history.location.state && props.history.location.state.username) {
      return props.history.location.state.username;
    }
    // 如果是从邮件中直接点连接定位过来，username从url里取
    return GetQueryString('username');
  }, [props.history.location.state]);
  const mode = useMemo(() => props.history.location.state?.mode, [props.history.location.state]);

  const handleSubmit = useCallback(async (): Promise<void> => {
    try {
      const { code } = getFieldsValue();
      set_button_loading(true);
      // 请求接口
      const request_body = {
        username,
        code: code.trim()
      };
      const send_res: any = await http_request_new({
        key: 'auth',
        props: props_new,
        url: `/${sso_path}/users/password/codevalide`,
        method: 1,
        body: request_body,
        no_refresh: 1
      });
      set_button_loading(false);
      if (send_res && !send_res.code) {
        notification.success({
          message: intl.formatMessage({ id: 'success' }),
          description: intl.formatMessage({ id: 'reset_pwd_valid' })
        });
        history.push({ pathname: LOGIN_URL.changePwd, state: { username: username, code } });
      }
    } catch (_err) {
      setTimeout(() => {
        set_button_loading(false);
      }, 300)
    }
  }, [getFieldsValue, username, props_new, history, intl, sso_path]);

  const handle_change_user = useCallback(() => {
    history.push(LOGIN_URL.forgotPwd);
  }, [history]);

  const resend_code = useCallback(async (): Promise<void> => {
    const res: any = await http_request_new({
      key: 'pwdresetemail',
      props: props_new,
      url: `/${sso_path}/users/${username}/pwdresetemail`,
      method: 0,
      no_refresh: 1,
      custom_warning: (response: any) => {
        const { code, message } = response;
        if (code >= 400) {
          notification.warning({
            message: intl.formatMessage({ id: 'warning' }),
            description: message
          });
        }
      }
    });
    if (res && !res.code) {
      notification.success({
        message: intl.formatMessage({ id: 'success' }),
        description: intl.formatMessage({ id: 'resend_code_success' })
      });
    }
  }, [username, props_new, intl, sso_path]);

  return (
    <Row className='retrieve-password-content' justify='center' align='middle'>
      <Card className='retrieve-password-box'>
        <Row className='box-title'>
          <FormattedMessage id='verify'></FormattedMessage>
        </Row>
        <Row className='box-subtitle'>
          <span>
            <FormattedMessage
              id='verify_sub_sso'
              values={{
                name: intl.formatMessage({ id: mode === 'phone' ? 'phone_s' : 'email_s' }),
                change: (
                  <span className='like-a' onClick={handle_change_user}>
                    {' '}
                    (<FormattedMessage id='change'></FormattedMessage>){' '}
                  </span>
                )
              }}
            ></FormattedMessage>
          </span>
          {/* <span className='like-a' onClick={handle_change_user}>
            (<FormattedMessage id='change'></FormattedMessage>)
          </span> */}
        </Row>

        <Form className='login-form' onFinish={handleSubmit} form={form}>
          <Form.Item name='code' rules={[{ required: true, message: intl.formatMessage({ id: 'p_i_activation_code' }) }]}>
            <Input placeholder={intl.formatMessage({ id: 'activation_code' })} size='large' />
          </Form.Item>
          <Form.Item>
            <Row className='box-button' justify='end' align='bottom'>
              <Button type='primary' size='large' htmlType='submit' className='login-form-button' loading={button_loading}>
                {' '}
                <FormattedMessage id='submit'></FormattedMessage>{' '}
              </Button>
            </Row>
          </Form.Item>
        </Form>
        <Row className='box-footer' align='bottom' justify='center'>
          <span className='like-a' onClick={resend_code}>
            <FormattedMessage id='resend_code'></FormattedMessage>
          </span>
        </Row>
      </Card>
    </Row>
  );
});
